import { extendDeep } from '../../../utils/utils';
import { mapFoldersToTree } from '../mappers/tree';
export const parseTree = function (res, parentId) {
  if (parentId === void 0) {
    parentId = null;
  }
  const {
    categories
  } = res.data;
  return extendDeep(res, {
    data: mapFoldersToTree(categories, parentId)
  });
};